import { render, staticRenderFns } from "./AssetListView.vue?vue&type=template&id=05f397d5&"
import script from "./AssetListView.vue?vue&type=script&lang=js&"
export * from "./AssetListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports